import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

import "./LoginPage.css";
import logo from "../../Media/Logo.png";
import Button from "../App/Common/Button/Button";
import * as Auth from "../../Utils/Auth";

const LoginPage = ({ logIn, isLoggedin }) => {
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (isLoggedin) navigate("/", { replace: true });
  }, [isLoggedin]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const authData = new FormData(event.currentTarget);
    let login = authData.get("login");
    let password = authData.get("password");
    Auth.authorize(login, password)
      .then((res) => {
        if (res) {
          setMessage("");
          logIn(res.access, password);
        }
      })
      .catch((e) => {
        setMessage("Неверный логин или пароль");
      });
  };

  return (
    <form className="loginPage__container" onSubmit={handleSubmit}>
      <img src={logo} alt="logo" />
      <h3>Личный кабинет ученика</h3>
      <TextField
        required
        type="text"
        id="login"
        label="Логин"
        name="login"
        autoFocus
        autoComplete="email"
        className="loginPage__input"
        sx={{ minWidth: "20%" }}
      />
      <FormControl
        margin="normal"
        variant="outlined"
        required
        className="loginPage__input"
        sx={{ minWidth: "20%" }}
      >
        <InputLabel htmlFor="password">Пароль</InputLabel>
        <OutlinedInput
          id="password"
          type={showPassword ? "text" : "password"}
          name="password"
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          label="Пароль"
          autoComplete="current-password"
        />
      </FormControl>
      {message ? <div className="error-message">{message}</div> : ""}
      <Stack
        direction={{ sm: "column", md: "column" }}
        justifyContent="space-between"
        alignItems="center"
        sx={{ minWidth: "20%", mb: 2 }}
        gap={2}
      >
        <FormControlLabel
          control={<Checkbox value="remember" />}
          label="Запомнить пароль"
        />
        <a type="text" href="/register">
          Зарегистрироваться
        </a>
      </Stack>

      <Button
        nativeType="submit"
        buttonText={"Войти"}
        color={"#7A5AF8"}
        type={"filled"}
      />
    </form>
  );
};
export default LoginPage;
